


<mat-sidenav-container class="trans-overlay" id="main-drawer-container" >
	<mat-sidenav #appSidenav mode="over" position="start" class="app-sidenav">
		<app-sidenav (onSideNvaAction)="onSideNvaAction($event)" [sideNav]="appSidenav" workMode="tabitOrder"></app-sidenav>
	</mat-sidenav>


	<div class="module-container animated faster fadeInUp">
		<div class="module-bar-fixed">
			@if (wizardStep == stepsMap.end) {

				<span class="title text-truncate">
					 <div>{{(stepsMapTitles[0]) | translate}}</div>
					@if ($storage.tableNumber) {
						<small style="position:relative;" [innerHTML]="'OAT.table_no_alt' | translate: {v: $storage.tableNumber} | safeHtml"></small>
					}
				</span>

			} @else {

			@if ($storage.hasBack || $storage.activeSubCat || wizardStep > stepsMap.menu) {
				<button mat-icon-button color="accent" (mousedown)="goBack()">
					<mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
				</button>
			}
			<span class="title _flex text-truncate">
			@if (wizardStep > stepsMap.menu) {
				@if (stepsMapTitles[wizardStep]) {
					<small style="position:relative; top:3px">{{stepsMapTitles[0] | translate}}</small>
					<div>{{(stepsMapTitles[wizardStep]) | translate}}</div>
				} @else {
					<div>{{(stepsMapTitles[0]) | translate}}</div>
				}
			} @else {
				<div>{{(stepsMapTitles[wizardStep]) | translate}}</div>

				<div class="d-flex align-items-center" style="gap:5px">

				@if(loading) {}
				@else if ($storage.tableNumber) {
					<small style="position:relative;"  [innerHTML]="'OAT.table_no_alt' | translate: {v: $storage.tableNumber} | safeHtml"></small>
				} @else {
					<small style="position:relative;">{{'TO.takeaway_title' | translate}}</small>
				}

				@if (orderService.$storage.canTakeaway ) {
					<button type="button" class="btn-inline-small ml-0" [matMenuTriggerFor]="otMenu" matRipple>
						<span>
							{{'TO.dine_in' | translate}}
						</span>
						<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
						  <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
						</svg>
					</button>
					<mat-menu #otMenu="matMenu">
					  <button mat-menu-item (click)="orderService.changeOrderToPickup()">
						<mat-icon svgIcon="package"></mat-icon>
						<div>{{'TO.change_to_takeaway' | translate}}</div>
					  </button>
					</mat-menu>
				}
				</div>
			}

			</span>
			@if (wizardStep == stepsMap.menu) {
				<!--@if ($storage.catalog?.enableTabot) {
					<span  (mousedown)="dialogsService.openAiChat()" style="width:40px;text-align: center">
						<img src="assets/icons/tabot-ai.svg" style="width:30px; height: 30px;">
					</span>
				}-->

				@if (appService.regionArgs.translations) {
					<button mat-icon-button color="accent" (mousedown)="toggleTranslation()">
						<mat-icon svgIcon="globe"></mat-icon>
					</button>
				}
				<button mat-icon-button color="accent" (mousedown)="searchCatalog()">
					<mat-icon svgIcon="search"></mat-icon>
				</button>
			} @else {
				<button id="btnShoppingCart" mat-icon-button color="accent" (mousedown)="checkout()"
						[matBadge]="$storage?.order?.quantity"
						[matBadgeHidden]="!$storage?.order?.quantity"
						matBadgeColor="primary" style="margin-inline-end: 5px">
					<mat-icon svgIcon="shopping-cart"></mat-icon>
				</button>
			}

			}
			@if (!$storage.menuDisabled) {
				@if (appService.user) {
					<button mat-mini-fab color="accent" (mousedown)="toggleAppSidenav()" style="box-shadow:none">
						{{ appService.user.initials }}
					</button>
				} @else {
					<button mat-icon-button color="accent" (mousedown)="toggleAppSidenav()">
						<mat-icon svgIcon="bars"></mat-icon>
					</button>
				}
			}

			<mat-menu #menu="matMenu">
				@if (wizardStep > stepsMap.menu && wizardStep > stepsMap.end) {
					<button mat-menu-item (click)="checkout()">
						<mat-icon svgIcon="shopping-cart"></mat-icon>
						<span>{{'TD.my-order' | translate}}</span>
					</button>
				}
				<button mat-menu-item (click)="restartOrder()">
					<mat-icon svgIcon="reload"></mat-icon>
					<span>{{'TO.restart-order' | translate}}</span>
				</button>
				@if (appService.enableLogin) {
					@if (!appService.user) {
						<button mat-menu-item (click)="signIn()">
							<mat-icon svgIcon="user_circle"></mat-icon>
							<span>{{'sign_in_nav' | translate}}</span>
						</button>
					} @else {
						<button mat-menu-item (click)="signOut()">
							<mat-icon svgIcon="signout"></mat-icon>
							<span>{{'logout' | translate}}</span>
						</button>
					}
				}
				<button mat-menu-item (click)="appService.showContractDialog('contract')">
					<mat-icon svgIcon="shield_check"></mat-icon>
					<span>{{'CONTRACT_C' | translate}}</span>
				</button>
				<button mat-menu-item (click)="appService.showContractDialog('privacy')">
					<mat-icon svgIcon="shield_keyhole"></mat-icon>
					<span>{{'CONTRACT_D' | translate}}</span>
				</button>
			</mat-menu>

		</div>

		<div class="module-body">
			@if(!loading) {
				<app-menu [hidden]="wizardStep != stepsMap.menu" (checkout)="checkout()" (onloyalty)="showLoyaltyDialog()"></app-menu>
				@switch (wizardStep) {
					@case (stepsMap.extras) {
						<app-tabit-order-extras (onNext)="goNext($event)"></app-tabit-order-extras>
					}
					@case (stepsMap.tip) {
						<app-tabit-order-tip (onNext)="goNext($event)"></app-tabit-order-tip>
					}
					@case (stepsMap.pay) {
						<app-tabit-order-pay (onOrderDone)="onOrderDone($event)"></app-tabit-order-pay>
					}
					@case (stepsMap.end) {
						<app-tabit-order-end (onEndOrder)="onEndOrder($event)"></app-tabit-order-end>
					}
				}
			}
		</div>

		@if ($storage.currentRoute === 'opentab') {
			<div class="open-tab-box fixed-bottom animated fadeInUpBig fast">
				<div class="alert-accent shadow-lg" (mousedown)="dialogsService.showTabOrderOptions({actions:[]})">
					<div class="alert-accent-header">
						<div class="_title">{{'OAT.menu_prompt_bottom_title' | translate}}</div>
						<mat-icon svgIcon="arrow_next" class="rotate-rtl"></mat-icon>
					</div>
					<div class="alert-accent-body">{{'OAT.menu_prompt_bottom_desc' | translate}}</div>
				</div>
			</div>
		} @else {
			<div class="ac-color p-3 pb-4 fixed-bottom" [class.fixedHidden]="!orderService.$storage?.basket[0]">
				<button class="btn-checkout" type="button" (click)="checkoutClick()" id="btnCheckout" [hidden]="wizardStep != stepsMap.menu">
					<div class="_inner">
						<div class="_icon">
							<mat-icon svgIcon="shopping-cart"></mat-icon>
							<div class="_counter" id="btnCheckoutCounter">{{$storage.order.quantity}}</div>
						</div>
						<div class="_caption">{{'TD.my-order' | translate}}</div>
						<div class="_price">{{$storage.order.grandTotal | lcurrency}}</div>
						<div class="_next"><mat-icon>{{appService.nextIcon}}</mat-icon></div>
					</div>
				</button>
			</div>
		}


	</div>
</mat-sidenav-container>


